<template>
  <section id="appgame">
    <div class="co-container-lg px-4 pt-5 text-left md:text-center">
      <h2 class="co-display-9 mb-5 text-center font-bold">
        アプリやゲーム制作に<br class="sm:hidden">興味がある方
      </h2>

      <div class="flex flex-wrap justify-between sm:justify-center">
        <!-- iPhoneアプリ -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/iphone"
        >
          <div class="te-course-title te-bg-iphone-trans-70 flex flex-col justify-center text-center font-bold text-white">
            iPhoneアプリ
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            最新のiPhoneアプリ開発手法でアプリ開発
          </div>
        </a>

        <!-- Androidアプリ -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/android"
        >
          <div class="te-course-title te-bg-android-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            Androidアプリ
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            Androidのアプリ開発手法でアプリ開発
          </div>
        </a>

        <!-- Unity -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/unity"
        >
          <div class="te-course-title te-bg-unity-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            Unity
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            Unityを利用してオリジナルのゲームアプリ制作
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-course-block {
  width: calc(50% - 8px);
  margin-bottom: 20px;
  border-radius: 6px;
  @media (min-width: 576px) {
    width: calc(33% - 16px);
  }
  @media (min-width: 992px) {
    width: calc(25% - 16px);
  }
  &:nth-child(odd) {
    margin-right: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
  }
  &:nth-child(even) {
    margin-left: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
    &:last-child {
      margin: 0 0 20px 8px;
      @media (min-width: 576px) {
        margin: 0 8px 20px;
      }
    }
  }
  &:nth-child(odd):last-child {
    margin: 0 0 20px;
    @media (min-width: 576px) {
      margin: 0 8px 20px;
    }
  }
}

/* コースタイトル */
.te-course-title {
  height: 92px;
  font-size: 0.75rem;
  border-radius: 6px 6px 0 0;
  @media (min-width: 576px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    height: 120px;
    font-size: 1.125rem;
  }
}

/* コースアイコン */
.te-course-icon {
  font-size: 1.25rem;
  @media (min-width: 992px) {
    font-size: 1.5rem;
  }
}

.te-course-caption {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    font-size: 1rem;
  }
}

.te-bg-iphone-trans-70 {
  background: linear-gradient(
      rgba(153, 153, 153, 0.7) 0%,
      rgba(153, 153, 153, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/MobileApp/bg-mobileapp.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-android-trans-70 {
  background: linear-gradient(
      rgba(164, 198, 57, 0.7) 0%,
      rgba(164, 198, 57, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/MobileApp/bg-mobileapp.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-unity-trans-70 {
  background: linear-gradient(
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/GameApp/bg-gameapp.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>

